import { shallowRef } from "vue";

class AppFullscreenSpinnerModel {
    private showSpinner = shallowRef(false);

    show = () => {
        this.showSpinner.value = true;
    };

    hide = () => {
        this.showSpinner.value = false;
    };
}

export const appFullScreenSpinnerModel = new AppFullscreenSpinnerModel();
